
import * as Yup from "yup";
import { passwordRegex } from "../../utils/regex/formRegexConstant";


export const aboutCompanyValidation = Yup.object().shape({
  businessName: Yup.string().required("Business name is required"),
  businessType: Yup.string().required("Business type is required"),
  businessLocation: Yup.object().when('businessType', {
    is: (val) => val === "store",
    then: (schema) =>
      schema.shape({
        // state: Yup.string().required("State is required"),
        // country: Yup.string().required("Country is required"),
        // city: Yup.string().required("City is required"),
        // pincode: Yup.string().required("Pincode is required"),
        // latitude: Yup.number().required("Latitude is required").typeError("Latitude must be a number"),
        // longitude: Yup.number().required("Longitude is required").typeError("Longitude must be a number"),
        address: Yup.string().required("Address is required"),
        // street: Yup.string().required("Street is required"),
      }),
    otherwise: (schema) => schema.notRequired(),
  }),
  registrationDocuments: Yup.array()
    .min(1, "At least one company document is required")
    .required("Company documents are required")
    .test(
      "all-registration-fields-required",
      "All registration document fields are required",
      function (value) {
        if (!value || value.length === 0) return false;

        return value.every(
          (doc) =>
            doc.name &&
            doc.name.trim() !== "" &&
            doc.expiryDate &&
            doc.expiryDate.trim() !== "" &&
            Array.isArray(doc.attachments) &&
            doc.attachments.length > 0
        );
      }
    ),

  idProof: Yup.array()
    .min(1, "At least one ID proof is required")
    .required("ID proof is required")
    .test(
      "all-idproof-fields-required",
      "All ID proof fields are required",
      function (value) {
        if (!value || value.length === 0) return false;

        return value.every(
          (doc) =>
            doc.name &&
            doc.name.trim() !== "" &&
            doc.expiryDate &&
            doc.expiryDate.trim() !== "" &&
            Array.isArray(doc.attachments) &&
            doc.attachments.length > 0
        );
      }
    ),
});

export const aboutYouValidation = Yup.object().shape({
  fullName: Yup.string()
    .matches(/^[a-zA-Z\s]+$/, "Full name can only contain letters and spaces")
    .required("Full name is required"),
  email: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Please enter a valid email address"
    )
    .required("Email is required"),
  mobile: Yup.string()
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),
});

export const passwordValidation = Yup.object().shape({
  password: Yup.string()
    .trim()
    .matches(
      passwordRegex,
      "Use a password with 8+ characters, 1 letter, 1 number, and 1 special character"
    )
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});